import Service				from "./../../Libs/Service";

let Testing = new Service({

	Name: "Testing",

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"IFrame Data:CreativeTestingData": function(data) {

			Object.assign(this.creativeTestingData, data);

		},

		"IFrame Data:MraidSDKMethodCall": function([methodName, params]) {

			this.processMraidSDKMethodCall(methodName, params);

			// Если активирован релиз applovin-tracking проверим трекинг аппловина
			if (Publisher.isReleaseActive("applovin-tracking")) this.processMraidSDKMethodCallApplovin(methodName, params);

			Broadcast.call("Testing Step Added");

		},

		"Refresh Iframe,Selected Version Switched": function() {

			this.clearMraidSDKSteps();

		}

	},

	Actions: {

	},

	init() {

		//Данные нод кластера: у каждой ноды своя БД, и id версий на разных нодах совпадают,
		//поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.creativeTestingDataByServer = {};

		this.mraidSDKSteps = [];
		this.mraidSDKEventsCalled = {};
		this.mraidSDKEventsSubscribed = {};
		this.mraidSDKMethodsCalled = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (creativeTestingData[...]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		// Будем записывать сюда информацию полученную из самого креатива для тестовых целей
		// например информацию об отключенных автоматических Applovin трекингов (DISABLED_APPLOVIN_TRACKINGS)
		this.creativeTestingData = this.getServerMap(this.creativeTestingDataByServer, serverId);

	},

	getMraidSDKStepsDefinition() {

		let tests = _.orderBy(_.filter(_.values(Metadata.Tests), test => {

			if (test["release_codename"]) return Publisher.isReleaseActive(test["release_codename"]);
			else if (test["publisher_codename"]) return Publisher?.SelectedPublisher?.codename === test["publisher_codename"];
			else return true;

		}), 'priority');

		return tests;

	},

	getMraidSDKStepDefinition(methodName, params) {

		let stepDefinition = null,
			mraidSDKStepsDefinition = this.getMraidSDKStepsDefinition();

		if (methodName === "track") {

			stepDefinition = _.find(mraidSDKStepsDefinition, stepDefinition => stepDefinition.type === "track" && stepDefinition.name === params[0]);

		} else if (methodName === "on") {

			stepDefinition = _.find(mraidSDKStepsDefinition, stepDefinition => stepDefinition.type === "event" && stepDefinition.name === params[0]);

		} else {

			stepDefinition = _.find(mraidSDKStepsDefinition, stepDefinition => stepDefinition.type === "method" && stepDefinition.name === methodName);

		}

		return stepDefinition;

	},

	processMraidSDKMethodCall(methodName, params) {

		let stepDefinition = this.getMraidSDKStepDefinition(methodName, params);

		let error = null,
			step = null;

		if (stepDefinition) {

			let error = null;

			_.each(stepDefinition.dependency, dependency => {

				if (dependency.first && this.mraidSDKSteps.length > 0) error = `"${stepDefinition.title}" should be called first`;
				if (dependency.eventTrack && !this.mraidSDKEventsCalled[dependency.eventTrack]) error = `"${stepDefinition.title}" should be called after MraidSDK.track('<b>${dependency.eventTrack}</b>')`;
				if (dependency.eventOn && !this.mraidSDKEventsSubscribed[dependency.eventOn]) error = `"${stepDefinition.title}" should be called after MraidSDK.on('<b>${dependency.eventOn}</b>')`;
				if (dependency.method && !this.mraidSDKMethodsCalled[dependency.method]) error = `${stepDefinition.title} should be called after MraidSDK.call('<b>${dependency.method}</b>')`;

			});

			stepDefinition.passed = !error;
			stepDefinition.error = error;

			// Если этот шаг пометился выполненным и у него есть зависимые шаги которые должны быть тоже помечемы выполненными - помечаем
			if (stepDefinition.passed && stepDefinition.exclude) {

				_.each(stepDefinition.exclude, excludeItem => {

					let excludeStepDefinition = this.getMraidSDKStepDefinition(excludeItem[0], excludeItem[1]);

					if (excludeStepDefinition) excludeStepDefinition.semiPassed = true;

				});

			}

		} else {

			let step = null;

			if (methodName === "call") {

				step = {
					title: `MraidSDK.call('<b>${params[0]}</b>')`,
					passed: !error,
					params,
					error
				};

			} else if (methodName === "on") {

				step = {
					title: `MraidSDK.on('<b>${params[0]}</b>')`,
					passed: !error,
					params,
					error
				};

			} else if (methodName === "track") {

				step = {
					title: `MraidSDK.track('<b>${params[0]}</b>')`,
					passed: !error,
					params,
					error
				};

			} else {

				step = {
					title: methodName,
					passed: !error,
					params,
					error
				};

			}

			this.mraidSDKSteps.push(step);

		}

		if (methodName === "track") this.mraidSDKEventsCalled[params[0]] = true;
		else if (methodName === "on") this.mraidSDKEventsSubscribed[params[0]] = true;
		else this.mraidSDKMethodsCalled[methodName] = true;

	},

	processMraidSDKMethodCallApplovin(methodName, params) {

		let disabledTrackings = Testing.creativeTestingData.DISABLED_APPLOVIN_TRACKINGS || [];

		// Принимаем трекинг по умолчанию для событий LOADING LOADED CHALLENGE_STARTED CTA_CLICKED и других если это поведение не было отключено через  DISABLED_APPLOVIN_TRACKINGS
		if (methodName === "initialized") this.processMraidSDKMethodCall("track", ["LOADING", []]);
		if (methodName === "track" && params[0] === "Assets Loaded") this.processMraidSDKMethodCall("track", ["LOADED", []]);
		if (methodName === "track" && params[0] === "Creative Loaded and Showed") this.processMraidSDKMethodCall("track", ["DISPLAYED", []]);
		if (methodName === "track" && params[0] === "First Click Occurred" && !disabledTrackings.includes('CHALLENGE_STARTED')) this.processMraidSDKMethodCall("track", ["CHALLENGE_STARTED", []]);
		if (methodName === "track" && params[0] === "End Screen Showed" && !disabledTrackings.includes('ENDCARD_SHOWN')) this.processMraidSDKMethodCall("track", ["ENDCARD_SHOWN", []]);
		if (methodName === "track" && params[0] === "End Screen Showed" && params[1]?.[0].indexOf && params[1]?.[0].indexOf('complete') !== -1 && !disabledTrackings.includes('CHALLENGE_SOLVED')) this.processMraidSDKMethodCall("track", ["CHALLENGE_SOLVED", []]);
		if (methodName === "track" && params[0] === "End Screen Showed" && params[1]?.[0].indexOf && params[1]?.[0].indexOf('fail') !== -1 && !disabledTrackings.includes('CHALLENGE_FAILED')) this.processMraidSDKMethodCall("track", ["CHALLENGE_FAILED", []]);
		if (methodName === "track" && params[0] === "Retry" && !disabledTrackings.includes('CHALLENGE_RETRY')) this.processMraidSDKMethodCall("track", ["CHALLENGE_RETRY", []]);
		if (methodName === "open" && !disabledTrackings.includes('CTA_CLICKED')) this.processMraidSDKMethodCall("track", ["CTA_CLICKED", []]);

		// Принимаем трегинг написанный руками для конкретной игры
		if (methodName === "track" && params[0] === "LOADING") this.processMraidSDKMethodCall("track", ["LOADING", []]);
		if (methodName === "track" && params[0] === "LOADED") this.processMraidSDKMethodCall("track", ["LOADED", []]);
		if (methodName === "track" && params[0] === "DISPLAYED") this.processMraidSDKMethodCall("track", ["DISPLAYED", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_STARTED") this.processMraidSDKMethodCall("track", ["CHALLENGE_STARTED", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_SOLVED") this.processMraidSDKMethodCall("track", ["CHALLENGE_SOLVED", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_FAILED") this.processMraidSDKMethodCall("track", ["CHALLENGE_FAILED", []]);
		if (methodName === "track" && params[0] === "ENDCARD_SHOWN") this.processMraidSDKMethodCall("track", ["ENDCARD_SHOWN", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_RETRY") this.processMraidSDKMethodCall("track", ["CHALLENGE_RETRY", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_PASS_25") this.processMraidSDKMethodCall("track", ["CHALLENGE_PASS_25", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_PASS_50") this.processMraidSDKMethodCall("track", ["CHALLENGE_PASS_50", []]);
		if (methodName === "track" && params[0] === "CHALLENGE_PASS_75") this.processMraidSDKMethodCall("track", ["CHALLENGE_PASS_75", []]);
		if (methodName === "track" && params[0] === "CTA_CLICKED") this.processMraidSDKMethodCall("track", ["CTA_CLICKED", []]);

	},

	clearMraidSDKSteps() {

		this.mraidSDKSteps = [];
		this.mraidSDKEventsCalled = {};
		this.mraidSDKMethodsCalled = {};

		_.each(Metadata.Tests, stepDefinition => {

			delete stepDefinition.passed;
			delete stepDefinition.semiPassed;
			delete stepDefinition.error;

		});

		Testing.creativeTestingData = {};

		Broadcast.call("Testing Steps Cleared");

	},

	getMraidSDKStatus() {

		let result = 'fully-passed',
			mraidSDKStepsDefinition = this.getMraidSDKStepsDefinition();

		for (let i=0, l=mraidSDKStepsDefinition.length; i<l; i++) {

			let step = mraidSDKStepsDefinition[i];

			// Если хотя бы один шаг дал ошибку - возвращаем статус error
			if (step.error) result = 'error';

			// Если не выполнен важный пункт - ставим статус не пройден
			else if (step.is_primary && !(step.passed || step.semiPassed) && result !== 'error') result = 'not-passed';

			// Если не выполнен дополнительный пункт - ставим статус частично пройден
			else if (!step.is_primary && !(step.passed || step.semiPassed) && result !== 'error' && result !== 'not-passed') result = 'partially-passed';

		}

		if (result === 'fully-passed' || result === 'partially-passed') {

			if (Version.SelectedVersion) {

				let status = this.getLastMraidSDKStatus();

				if (!status || (result === 'fully-passed' && status === 'partially-passed')) {

					Version.SelectedVersion.options.tests.status = result;
					Version.SelectedVersion.options.tests.timestamp = Date.now();

					Server.sendToSocket({
						SetVersionTestsStatus: {
							versionId: Version.SelectedVersion.id,
							testsStatus: result
						}
					});

				}

			}

		}

		return result;

	},

	getLastMraidSDKStatus() {

		if (!Version.SelectedVersion.options) Version.SelectedVersion.options = {};
		if (!Version.SelectedVersion.options.tests) Version.SelectedVersion.options.tests = {};

		let status = Version.SelectedVersion.options.tests.status || null,
			timestamp = Version.SelectedVersion.options.tests.timestamp || 0;

		// Если время последнего обновления креатива больше чем время статуса тестов - считаем сохранённый статус устаревшим
		if (timestamp && timestamp < Creative.SelectedCreative["last_update_timestamp"]) status = null;

		return status;

	}

});

window.Testing = Testing;

export { Testing }

